export const IDENTIFIER_COLUMNS = [
  "figi",
  "sedol",
  "cusip",
  "isin",
  "fs_perm_id",
  "bloomberg_ticker",
  "factset_ticker",
  "arcana_id",
  "name",
];

export const resolveSecuritiesRequest = {
  action: "resolve_securities",
  data: {
    identifiers: [],
    fields: IDENTIFIER_COLUMNS,
  },
};
